// import { Helmet } from "react-helmet-async";

// type PageMetaProps = {
//   title: string;
//   description: string;
//   ogTitle?: string;
//   ogDescription?: string;
//   path?: string;
// };

// const SITE_URL = "https://santhila.co";

// export function PageMeta({
//   title,
//   description,
//   ogTitle,
//   ogDescription,
//   path = "",
// }: PageMetaProps) {
//   const canonical = `${SITE_URL}${path}`;

//   return (
//     <Helmet>
//       <title>{title}</title>
//       <meta name="description" content={description} />
//       <link rel="canonical" href={canonical} />
//       <meta property="og:title" content={ogTitle ?? title} />
//       <meta property="og:description" content={ogDescription ?? description} />
//       <meta property="og:url" content={canonical} />
//       <meta name="twitter:title" content={ogTitle ?? title} />
//       <meta name="twitter:description" content={ogDescription ?? description} />
//     </Helmet>
//   );
// }
import { Helmet } from "react-helmet-async";

type PageMetaProps = {
  title: string;
  description: string;
  ogTitle?: string;
  ogDescription?: string;
  path?: string;
  ogType?: string;
  ogImage?: string;
  ogSiteName?: string;
  twitterCard?: string;
  twitterImage?: string;
};

const SITE_URL = "https://santhila.co";

export function PageMeta({
  title,
  description,
  ogTitle,
  ogDescription,
  path = "",
  ogType = "website",
  ogImage,
  ogSiteName = "Santhila",
  twitterCard = "summary_large_image",
  twitterImage,
}: PageMetaProps) {
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle ?? title} />
      <meta property="og:description" content={ogDescription ?? description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={ogSiteName} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={ogTitle ?? title} />
      <meta name="twitter:description" content={ogDescription ?? description} />
      {twitterImage && <meta name="twitter:image" content={twitterImage} />}
    </Helmet>
  );
}